<template>
  <div
    class="bottom bg-primary"
    id="dropshipSteps">
    <div class="row text-light">
      <div class="col-12 text-center">
        <div class="my-2">
          <small>
            {{stepText}}
          </small>
        </div>
      </div>
      <!-- Step Tracker -->
      <!-- Step 1 -->
      <div class="col text-center p-0">
        <Indicator
          v-if="activeStep >= 1"
          :activeStep="activeStep"
          position="1"
          first="true"/>
        <i v-else class="far fa-circle sized"/>
      </div>
      <!-- Step 2 -->
      <div class="col text-center p-0">
        <Indicator
          v-if="activeStep >= 2"
          :activeStep="activeStep"
          position="2"/>
        <i v-else class="far fa-circle sized"/>
      </div>
      <!-- Step 3 -->
      <div class="col text-center p-0">
        <Indicator
          v-if="activeStep >= 3"
          :activeStep="activeStep"
          position="3"/>
        <i v-else class="far fa-circle sized"/>
      </div>
      <!-- Step Next -->
      <!-- <div class="col text-center">
        <template v-if="activeStep == 3">
          <button
            class="btn btn-sm btn-primary animate__animated animate__bounceIn animate__faster"
            @click="goto('cart')">
            Checkout
            <i class="fa fa-shopping-cart"/>
          </button>
        </template>
      </div> -->
    </div>
  </div>
</template>

<script setup>
  import Indicator from './Indicator.vue'
  import { computed } from 'vue'
  import { useRouter } from 'vue-router'

  // Initialize
  const props = defineProps(['activeStep'])
  const router = useRouter()

  // Methods
  const goto = (view)=>{
    router.push({path: `/${view}`})
  }

  // Computed
  const stepText = computed(()=>{
    let text
    switch(props.activeStep){
      case 1:
        text = 'Read & Understand Policy'
        break;
      case 2:
        text = 'Select a Manufacturer'
        break;
      case 3:
        text = 'Select Products'
        break;
      case 4:
        text = 'Order Details'
        break;
      case 5:
        text = 'Order Confirmation'
        break;
    }
    return text
  })

</script>

<style scoped>
  @media(min-width: 992px){
    .bottom{
      right: 15px !important;
    }
  }
  .bottom{
    position: fixed;
    bottom: 0em;
    left: 0px;
    height: 6em;
    background: var(--bs-white);
    padding: 0em 12em;
    border-top: 1px solid lightgray;
  }
</style>
